import MarketAPI from "@/api/market.api";

const MarketStore = {
  namespaced: true,
  state: {
    products: [],
    selectedBuyingProduct: null,
  },
  mutations: {
    loadProducts(state, payload) {
      state.products = payload;
    },
    buyProduct(state, productId) {
      state.selectedBuyingProduct = productId
    }
  },
  actions: {
    async loadAll({dispatch}) {
      await dispatch('loadProducts');
    },
    async loadProducts({commit}) {
      const products = await MarketAPI.getProducts();
      commit('loadProducts', products)
    },
  },
  getters: {
    products: state => state.products,
    getProductById: state => productId => state.products
        .find(product => Number(product.id) === Number(productId))
  },
}

export default MarketStore;
